import { Component } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ApiConfiguration } from "src/app/services/http/api-configuration";

// Public, unauthenticated page (no AuthGuardService on its route in
// app-routing.module.ts, same as /signin and /privacy-policy) - Google
// Play's "Account deletion" policy requires a stable public URL explaining
// how to request deletion, reachable even by a user who can't or won't log
// in. Submitting the form raises a ticket_type=4 helpdesk ticket (see
// appapi's TicketController::actionRequestAccountDeletion) for staff to
// action manually - this does not delete anything automatically.
//
// Uses HttpClient directly rather than the shared ApiService: ApiService's
// post() unconditionally reads a program_id out of localStorage (set at
// login) outside of a try/catch, which throws on a page with no logged-in
// session.
@Component({
  selector: "app-delete-account-public",
  templateUrl: "./delete-account-public.component.html",
  styleUrls: ["./delete-account-public.component.scss"],
})
export class DeleteAccountPublicComponent {
  mobile = "";
  email = "";
  reason = "";

  submitting = false;
  submitted = false;
  errorMessage = "";
  successMessage = "";
  ticketId = "";

  constructor(
    private http: HttpClient,
    private apiConfig: ApiConfiguration,
  ) {}

  onSubmit() {
    this.errorMessage = "";
    this.submitted = true;

    const mobile = (this.mobile || "").trim();
    if (!/^[0-9]{10}$/.test(mobile)) {
      this.errorMessage = "Enter the 10-digit mobile number registered on your Pigeon Cares account.";
      return;
    }

    this.submitting = true;
    const payload = {
      program_id: 1,
      mobile_no: mobile,
      email: (this.email || "").trim(),
      reason: (this.reason || "").trim(),
    };
    const headers = new HttpHeaders({ "Content-Type": "application/json" });

    this.http
      .post<any>(this.apiConfig.requestAccountDeletion, payload, { headers, observe: "response" })
      .subscribe(
        (res: any) => {
          this.submitting = false;
          this.successMessage = res.body && res.body.data && res.body.data.message
            ? res.body.data.message
            : "Your account deletion request has been received.";
          this.ticketId = res.body && res.body.data ? res.body.data.ticket_id : "";
          this.mobile = "";
          this.email = "";
          this.reason = "";
          this.submitted = false;
        },
        (err) => {
          this.submitting = false;
          this.errorMessage = err && err.error && err.error.data && err.error.data.message
            ? err.error.data.message
            : "Something went wrong submitting your request. Please try again.";
        }
      );
  }
}
